import { AppSEO } from "@hl/shared-features/lib/features/layout";
import { Error } from "@hl/shared-features/lib/features/layout/Error";

import { TOOLS_URL } from "../../config";

export const PortfolioNotFound = () => {
  const loadLargeImage = (onLoad: (src: string) => void) =>
    import("../../assets/images/earth-dusk.jpg").then((img) =>
      onLoad(img.default)
    );
  return (
    <>
      <AppSEO title="This portfolio is not available." />

      <Error
        description="This portfolio is not available."
        loadLargeImage={loadLargeImage}
        loadSmallImage={loadLargeImage}
        redirectUrl={`${TOOLS_URL.base}/portfolio`}
        buttonLabel="Create your own"
      />
    </>
  );
};
